import React, { useEffect, useState } from "react";
import chata from "../assets/Group 28.png";
import bee from "../assets/Group 32.png";
import smallbee from "../assets/8f3479b9762001f0370cb94e488635a5a1211592.gif";


function Hero({round,winner,block,jackpot,splitCountdown}) {


  return (
    <div>
      <div className="bdgg">
        <div className="row m-0 p-0">
          <div className="col-12 col-md-3 p-0">
            <img src={chata} alt="" className="w-100" />
          </div>
          <div className="col-12 col-md-6 float-center">
            <div className="d-flex justify-content-center w-100">
              <img src={bee} alt="" className="w-100 " />
            </div>
            <p className="fs-4 text-center text-white" style={{ letterSpacing: "2px" }}>
              Smart People always have a plan Bee🐝
            </p>
            <p className="fs-4 text-center textcoloo" style={{ letterSpacing: "2px" }}>
              Jackpot Prize Pool = {jackpot} USDT <br />
              Current Jackpot Winner ={winner} Number  <br />
              {splitCountdown === 0 ? (
  <>Countdown to Jackpot = {block} Blocks</>
) : (
  <>Next round will be start = {splitCountdown}</>
)}
              
              <br /> Current Round = {round} <br />
            
            </p>
          
          </div>
          <div className="col-12 col-md-3 d-flex justify-content-center align-items-center">
            <img src={smallbee} alt="" className="" width={100} height={100} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
